/**
 * UpdateUserForm Component
 * UI-komponent för att uppdatera befintlig användare
 * Endast rendering + event handlers - all logik i useUserForm hook
 */

import React from 'react';
import { UserFormFields } from './UserFormFields';
import { useUserForm } from '../hooks/useUserForm';

function UpdateUserForm({ 
  selectedUser, 
  setUsers, 
  users, 
  builders = [], 
  onClose, 
  currentUser, 
  onSuccess 
}) {
  const {
    values,
    setValues,
    suppliers,
    previewUrl,
    errors,
    isLoading,
    isSendingEmail,
    errorMessage,
    successMessage,
    handleChange,
    handleAvatarChange,
    handleRemoveAvatar,
    handleSubmit,
    handleSendWelcomeEmail
  } = useUserForm({
    initialUser: selectedUser,
    onClose,
    onSuccess,
    setUsers,
    users,
    defaultRole: '',
    isUpdate: true
  });

  const isAdmin = currentUser?.role === 'admin' || currentUser?.hasAdminAccess;

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">Uppdatera användare</h2>
      
      {errorMessage && (
        <div className="mb-4 bg-red-50 p-3 border border-red-300 rounded text-red-800">
          {errorMessage}
        </div>
      )}
      
      {successMessage && (
        <div className="mb-4 bg-green-50 p-3 border border-green-300 rounded text-green-800">
          {successMessage}
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <UserFormFields
          values={values}
          setValues={setValues}
          errors={errors}
          builders={builders}
          suppliers={suppliers}
          previewUrl={previewUrl}
          handleChange={handleChange}
          handleAvatarChange={handleAvatarChange}
          handleRemoveAvatar={handleRemoveAvatar}
          isUpdate={true}
          isAdmin={isAdmin}
          showPasswordFields={isAdmin}
          showEmailOptions={false}
          onSendWelcomeEmail={handleSendWelcomeEmail}
          isSendingEmail={isSendingEmail}
        />
        
        <div className="flex space-x-4 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 bg-gray-500 text-white p-2 rounded hover:bg-gray-600 
                     transition-colors duration-200"
          >
            Avbryt
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="flex-1 bg-leadme-pink text-white p-2 rounded hover:bg-leadme-pink-dark 
                     disabled:bg-leadme-pink/50 transition-colors duration-200"
          >
            {isLoading ? 'Sparar...' : 'Spara'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default UpdateUserForm;

